import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";

export default function AboutUs() {
  return (
    <div className="min-h-screen flex flex-col bg-neutral-50">
      <SEO title="About Juwai Teer | Teer Result Portal" description="About Juwai Teer — a central Teer results portal for all 21 games." path="/about" />
      <Header />
      <main className="flex-1 max-w-3xl w-full mx-auto px-4 py-10">
        <h1 className="font-heading font-black tracking-tight text-3xl sm:text-4xl">About Juwai Teer</h1>
        <div className="mt-4 space-y-4 text-neutral-700 leading-relaxed">
          <p>
            Juwai Teer is a central results portal that tracks 21 Teer results in one place. We publish the latest
            FR and SR results for each Teer and keep a historical record so visitors can look up past dates.
          </p>
          <p>
            The portal is intentionally lightweight and mobile-first — every Teer has its own compact card on the
            homepage and its own dedicated result, previous results and common number pages.
          </p>
          <p className="text-sm text-neutral-500">
            All game times displayed on the site follow Indian Standard Time (IST / Asia/Kolkata). Any historical
            entries labeled as demo were generated for testing purposes and can be replaced with verified results
            by the site administrator.
          </p>
          <div className="mt-6 p-4 rounded-xl border border-amber-200 bg-amber-50 text-xs text-amber-900">
            <strong>Disclaimer:</strong> Numbers and results displayed on this site are informational. Please cross-verify with official Teer counter sources before acting on any information shown here.
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
